import { DialogService } from '../../shared/ui/dialog/dialog.service';
import { SnackbarService } from '../../shared/ui/snackbar/snackbar.service';
import { DialogData } from '../models/dialog.model';
import { SnackbarData } from '../models/snackbar.model';
import {
  openDialog,
  closeDialog,
  openSnackbar,
  closeSnackbar,
} from '../actions/page.action';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class PageEffects {
  openDialog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(openDialog),
      mergeMap((payload: { dialogData: DialogData }) => {
        const dialogRef = this.dialogService.openDialog(payload.dialogData);

        return dialogRef.afterClosed();
      }),
      map(() => closeDialog())
    )
  );

  openSnackbar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(openSnackbar),
      mergeMap((payload: { snackbarData: SnackbarData }) => {
        const snackbarRef = this.snackbarService.openSnackbar(
          payload.snackbarData
        );

        return snackbarRef.afterDismissed();
      }),
      map(() => closeSnackbar())
    )
  );

  constructor(
    private actions$: Actions,
    private dialogService: DialogService,
    private snackbarService: SnackbarService
  ) {}
}
